export default __webpack_public_path__ + "static/media/Major Rune Stone of the First Circle (V).94f09f16.jpg";